import { Backdrop, Paper, styled, InputLabel, TextField, InputAdornment, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { setServerResponse } from "store/application/application-action";
import colors from "../../../theme/themeConstants";
import RoundButton from "../../buttons/RoundButton";
import cross from "components/icons/cross-black.svg";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
  fixedEmbedCode: string;
  responsiveEmbedCode: string;
}

export const EmbedCodePopup = (props: IProps) => {
  const { isOpen, togglePopup, fixedEmbedCode, responsiveEmbedCode } = props;

  const dispatch = useDispatch();

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent) => {
    handleStopPropagation(event);
    togglePopup();
  };

  const copyFixed = () => {
    try {
      navigator.clipboard.writeText(fixedEmbedCode);
      dispatch(setServerResponse("Copied!"));
    } catch (e) {
      dispatch(setServerResponse("Error copying the link, sorry."));
    }
  };

  const copyResponsive = () => {
    try {
      navigator.clipboard.writeText(responsiveEmbedCode);
      dispatch(setServerResponse("Copied!"));
    } catch (e) {
      dispatch(setServerResponse("Error copying the link, sorry."));
    }
  };

  return (
    <Backdrop
      open={isOpen}
      onClick={handleClose}
      sx={{
        zIndex: "var(--popupZ)",
      }}
    >
      <Paper
        onClick={handleStopPropagation}
        sx={{
          height: "auto",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          maxWidth: "25rem",
          position: "absolute",
          bottom: isOpen ? "40vh" : "-15rem",
          transition: "bottom 300ms cubic-bezier(0, 0, 1, 1) 0ms",
          borderRadius: "24px",
          padding: "2rem 1rem 0 1rem",
          paddingBottom: "1rem",
          "@media screen and (max-width: 767px)": {
            maxWidth: "90vw"
          }
        }}
      >
        <FlexContainer>
          <h3 style={{ fontSize: "20px", fontWeight: 500, }}>Embed:</h3>
          <RoundButton img={cross} bgColor={"transparent"} onClick={handleClose} imgSize="28px" />
        </FlexContainer>
        <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>
          Fixed frame
        </InputLabel>
        <TextField
          sx={{
            "& div": {
              borderRadius: "12px",
              margin: "0.5rem 0",
              "& input": {
                padding: "13px 16px",
                fontSize: "14px"
              }
            }
          }}
          fullWidth
          value={fixedEmbedCode}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end' style={{ width: "fit-content" }}>
                <Button sx={{ color: colors.redPink }} onClick={copyFixed}>Copy</Button>
              </InputAdornment>
            )
          }}
        />
        <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>
          Responsive frame
        </InputLabel>
        <TextField
          sx={{
            "& div": {
              borderRadius: "12px",
              margin: "0.5rem 0",
              "& input": {
                padding: "13px 16px",
                fontSize: "14px"
              }
            }
          }}
          fullWidth
          value={responsiveEmbedCode}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end' style={{ width: "fit-content" }}>
                <Button sx={{ color: colors.redPink }} onClick={copyResponsive}>Copy</Button>
              </InputAdornment>
            )
          }}
        />
      </Paper>
    </Backdrop>
  );
};

const FlexContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  marginBottom: "1rem"
});
